import { INGRESOS } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null, 
    ventana_filtros: false
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case INGRESOS.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case INGRESOS.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        case INGRESOS.AGREGAR:
            let ingresos_agregar = state.listado;

            ingresos_agregar = [
                ...ingresos_agregar, payload
            ];

            ingresos_agregar = ingresos_agregar.sort(function (a, b) {
                if (a.fecha > b.fecha) {
                    return -1;
                }
                if (a.fecha < b.fecha) {
                    return 1;
                }
                return 0;
            });

            return {
                ...state, 
                listado: ingresos_agregar
            };

        case INGRESOS.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case INGRESOS.EDITAR:
            let ingresos_editar = state.listado;

            ingresos_editar = ingresos_editar.map(ingreso => ingreso.id === payload.id ? payload : ingreso);

            ingresos_editar = ingresos_editar.sort(function (a, b) {
                if (a.fecha > b.fecha) {
                    return -1;
                }
                if (a.fecha < b.fecha) {
                    return 1;
                }
                return 0;
            });

            return {
                ...state, 
                listado: ingresos_editar
            };

        case INGRESOS.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( ingreso => ingreso.id !== payload )
            };
        
        default:
            return state;
    }
}